(function ($) {
  Drupal.behaviors.anr_repromote_formatter_v1 = {
    attach: function (context) {
      $('.anr_repromote_formatter_v1', context).once(function () {
        $(window).on('load', function () {
          // Remove the spinner.
          $('.boutiques_spinner_v1_target').fadeOut();
        });
      });
    }
  };
})(jQuery);
